var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":"微信支付","left-text":"返回","left-arrow":""},on:{"click-left":_vm.goBack}}),_c('div',{staticClass:"pay-box"},[(_vm.isWeixin)?_c('div',{staticClass:"wx-notify"},[_vm._v("等待微信支付...")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("支付参数不正确！")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }